import api from '@services/api';
import { ResourceDonorRequest, ResourceDonorsResponse } from '../models/resourceDonors';

export const ResourceDonorsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    resourceDonorAll: builder.query<ResourceDonorsResponse[], string>({
      query: (searchTerm) => {
        return {
          url: `/indirect/rule-resource-provider/searchBy?searchTerm=${searchTerm || ''}`,
        };
      },
      providesTags: ['ResourceDonorAll'],
    }),
    resourceDonorSearchBy: builder.query<ResourceDonorsResponse[], string>({
      query: (input) => {
        return {
          url: `/indirect/rule-resource-provider/searchBy?searchTerm=${input}`,
        };
      },
      providesTags: ['ResourceDonorAll'],
    }),
    createResourceDonor: builder.mutation<void, ResourceDonorRequest>({
      query: (input) => {
        return {
          url: `/indirect/rule-resource-provider/create`,
          method: 'POST',
          body: input,
        };
      },
      invalidatesTags: ['ResourceDonorAll'],
    }),
    deleteDonor: builder.mutation<void, number>({
      query: (request) => ({
        url: encodeURI(`/indirect/rule-resource-provider/delete?id=${request}`),
        method: 'DELETE',
      }),
      invalidatesTags: ['ResourceDonorAll'],
    }),
  }),
});

export const {
  useResourceDonorSearchByQuery,
  useResourceDonorAllQuery,
  useCreateResourceDonorMutation,
  useDeleteDonorMutation,
} = ResourceDonorsApi;
